module.exports = __webpack_public_path__ + "static/media/Element_2_treatments.064aacfe.svg";